import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_button_icon = _resolveComponent("c-button-icon")!
  const _component_map_download_dropdown = _resolveComponent("map-download-dropdown")!
  const _component_map_view_selector = _resolveComponent("map-view-selector")!
  const _component_c_toggle = _resolveComponent("c-toggle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_c_button_icon, {
      class: "map-options__item",
      "data-tour": _ctx.TourSelector.ZOOM_IN,
      "icon-name": _ctx.faPlus.iconName,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit(_ctx.ComponentEvent.ZOOM_IN)))
    }, null, 8, ["data-tour", "icon-name"]),
    _createVNode(_component_c_button_icon, {
      class: "map-options__item",
      "data-tour": _ctx.TourSelector.ZOOM_OUT,
      "icon-name": _ctx.faMinus.iconName,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit(_ctx.ComponentEvent.ZOOM_OUT)))
    }, null, 8, ["data-tour", "icon-name"]),
    _createVNode(_component_c_button_icon, {
      class: "map-options__item",
      "data-tour": _ctx.TourSelector.PIN,
      "icon-name": _ctx.faMapMarkerAlt.iconName,
      "is-active": _ctx.isShowPopoverActive,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit(_ctx.ComponentEvent.SHOW_POPOVER)))
    }, null, 8, ["data-tour", "icon-name", "is-active"]),
    _createVNode(_component_map_download_dropdown, {
      class: "map-options__item",
      "shadow-root": _ctx.shadowRoot,
      onDownloadImage: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit(_ctx.ComponentEvent.DOWNLOAD_IMAGE))),
      onDownloadPDF: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit(_ctx.ComponentEvent.DOWNLOAD_PDF))),
      onDownloadFile: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit(_ctx.ComponentEvent.DOWNLOAD_FILE)))
    }, null, 8, ["shadow-root"]),
    _createVNode(_component_map_view_selector, {
      class: "map-options__item",
      "current-view": _ctx.currentView,
      "shadow-root": _ctx.shadowRoot,
      onChangeView: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit(_ctx.ComponentEvent.CHANGE_VIEW, $event)))
    }, null, 8, ["current-view", "shadow-root"]),
    _createVNode(_component_c_toggle, {
      class: "map-options__item map-options__climate-toggle",
      "model-value": _ctx.showClimateData,
      label: _ctx.$t('mapOptions.showClimateData'),
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit(_ctx.ComponentEvent.TOGGLE_CLIMATE_DATA, $event)))
    }, null, 8, ["model-value", "label"])
  ]))
}